import React from 'react';
import { motion } from 'framer-motion';
import { Layers } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { AdminPlatformsTab } from './AdminPlatformsTab';

export function AdminPage() {
  const { user } = useAuth();
  const isHkAdmin = String(user?.roleCode || '').toUpperCase() === 'HK_SUPPORT';

  if (!isHkAdmin) {
    return (
      <motion.section
        className="panel-card"
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.36, ease: [0.22, 1, 0.36, 1] }}
      >
        <h2>Admin access required</h2>
        <p className="hint-text">Only users with HK Administrator role can manage the platform catalog.</p>
      </motion.section>
    );
  }

  return (
    <section className="admin-stack">
      <motion.article
        className="panel-card admin-platforms-panel"
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="panel-title">
          <Layers size={16} />
          <h2>Platform Catalog</h2>
        </div>
        <AdminPlatformsTab />
      </motion.article>
    </section>
  );
}
